import server from 'server';

const API_URL = IS_MOBILE ? server.SERVER_URL + '/api' : '/api';

export default {
    API_URL
};
